import { api } from 'common';

import { InsuranceCardFormFields } from './FormFields';
import { insuranceCardDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const insuranceCardNodeConfig: BlockConfigProps<api.FlowDefinition.InsuranceCardBlockConfig> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'insuranceCard',
    defaultConfig: {
      gsPath: '',
    },
    configFields: {
      schema: api.FlowDefinition.InsuranceCardBlockConfigSchema,
      FormFields: InsuranceCardFormFields,
    },
    documentationMarkdown: insuranceCardDocumentationMarkdown,
  };
